// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg width=\"100\" height=\"100\" xmlns=\"http://www.w3.org/2000/svg\"><defs><pattern id=\"grid\" width=\"40\" height=\"40\" patternUnits=\"userSpaceOnUse\"><path d=\"M 40 0 L 0 0 0 40\" fill=\"none\" stroke=\"rgba%28255,255,255,0.05%29\" stroke-width=\"1\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url%28%23grid%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* NMBU Color Palette - Professional Design System */
  --color-green-dark: #025c4f;
  --color-green-dark-default: #025c4f;
  --color-green-light: #dbf8f4;
  --color-green-light-default: #dbf8f4;
  --color-green: #025c4f;
  --color-green1: #009a81;
  --color-green2: #46b4a0;
  --color-green3: #8bcec0;
  --color-green4: #d1e8df;
  --color-green6: #247761;
  --color-green7: rgba(0, 154, 129, .5);
  --color-purple: #53143a;
  --color-beige: #e7e3d1;
  --color-beige-light: #f6f6ee;
  --color-pink-light: #efc3cd;
  --color-blue-light: #d4ddef;
  --color-neutral: #333;
  --color-neutral1: #4d4d4d;
  --color-neutral2: #999;
  --color-neutral3: #e6e6e6;
  --color-neutral4: #f0f0f0;
  --color-neutral5: #c4c4c4;
  
  /* Semantic Mappings */
  --primary-green: #009a81;
  --primary-green-light: #46b4a0;
  --primary-green-dark: #025c4f;
  --primary-blue: #d4ddef;
  --primary-blue-dark: #53143a;
  --accent-purple: #53143a;
  --accent-pink: #efc3cd;
  --text-dark: #333;
  --text-medium: #4d4d4d;
  --text-light: #999;
  --bg-primary: #f6f6ee;
  --bg-secondary: #e7e3d1;
  --border-light: #e6e6e6;
  --border-medium: #c4c4c4;
  --white: #ffffff;
  --error-red: #d32f2f;
  --success-green: #009a81;
  --warning-yellow: #ffa726;
  --shadow-sm: 0 1px 3px 0 rgba(2, 92, 79, 0.1), 0 1px 2px 0 rgba(2, 92, 79, 0.06);
  --shadow-md: 0 4px 6px -1px rgba(2, 92, 79, 0.1), 0 2px 4px -1px rgba(2, 92, 79, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(2, 92, 79, 0.1), 0 4px 6px -2px rgba(2, 92, 79, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(2, 92, 79, 0.1), 0 10px 10px -5px rgba(2, 92, 79, 0.04);
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.App {
  min-height: 100vh;
  background: linear-gradient(135deg, var(--bg-primary) 0%, var(--color-beige-light) 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  font-size: 17px;
  line-height: 1.6;
  color: var(--text-dark);
}

.header {
  background: linear-gradient(135deg, var(--color-green-dark) 0%, #1a6b5a 50%, var(--color-green6) 100%);
  color: var(--white);
  padding: 18px 32px;
  box-shadow: 0 2px 12px rgba(2, 92, 79, 0.25);
  position: relative;
  overflow: hidden;
  z-index: 101;
}

.header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.3;
}

.header h1 {
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.3px;
  position: relative;
  z-index: 1;
}

/* ── Crop Breadcrumb in Header ── */
.back-to-crops-btn {
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.3);
  color: #ffffff;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
  position: relative;
  z-index: 1;
  white-space: nowrap;
}

.back-to-crops-btn:hover {
  background: rgba(255,255,255,0.25);
  transform: translateX(-2px);
}

.crop-breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255,255,255,0.12);
  padding: 6px 16px;
  border-radius: 20px;
  position: relative;
  z-index: 1;
}

.crop-breadcrumb-icon {
  font-size: 22px;
}

.crop-breadcrumb-name {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.3px;
}

.nav {
  background: var(--white);
  padding: 0;
  display: flex;
  align-items: center;
  gap: 0;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  border-bottom: 1px solid var(--border-light);
  position: sticky;
  top: 0;
  z-index: 100;
  overflow-x: auto;
}

.nav-divider {
  display: block;
  width: 1px;
  height: 24px;
  background: linear-gradient(180deg, transparent, var(--border-medium), transparent);
  margin: 0 6px;
  flex-shrink: 0;
}

.nav button {
  background: none;
  border: none;
  color: var(--text-medium);
  cursor: pointer;
  padding: 14px 22px;
  font-size: 15px;
  font-weight: 500;
  border-bottom: 3px solid transparent;
  transition: all 0.15s ease;
  position: relative;
  white-space: nowrap;
}

.nav button:hover {
  color: var(--color-green-dark);
  background-color: rgba(0, 154, 129, 0.06);
}

.nav button.active {
  color: var(--color-green-dark);
  font-weight: 600;
  border-bottom-color: var(--color-green1);
  background-color: rgba(0, 154, 129, 0.05);
}

.nav button.active::after {
  content: none;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 32px 24px;
}

.card {
  background: var(--white);
  border-radius: 12px;
  padding: 28px;
  margin-bottom: 24px;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-light);
}

.card:hover {
  box-shadow: var(--shadow-md);
}

.card h2 {
  margin: 0 0 20px 0;
  color: var(--text-dark);
  font-size: 26px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 16px;
  border-bottom: 2px solid var(--border-light);
}

.card h2::before {
  content: '';
  width: 4px;
  height: 28px;
  background: linear-gradient(180deg, var(--color-green1), var(--color-green6));
  border-radius: 4px;
}

.upload-section {
  border: 2px dashed var(--border-medium);
  border-radius: 12px;
  padding: 48px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: linear-gradient(135deg, rgba(0, 154, 129, 0.03) 0%, rgba(70, 180, 160, 0.03) 100%);
  position: relative;
  overflow: hidden;
}

.upload-section::before {
  content: '📁';
  font-size: 64px;
  opacity: 0.1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.upload-section:hover {
  background: linear-gradient(135deg, rgba(0, 154, 129, 0.08) 0%, rgba(70, 180, 160, 0.08) 100%);
  border-color: var(--color-green1);
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.upload-section input[type="file"] {
  display: none;
}

.btn {
  background: linear-gradient(135deg, var(--color-green1) 0%, var(--color-green-dark) 100%);
  color: var(--white);
  border: none;
  padding: 12px 28px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: var(--shadow-sm);
  letter-spacing: 0.3px;
  position: relative;
  overflow: hidden;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.btn:hover::before {
  left: 100%;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.btn:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
}

.btn:disabled {
  background: var(--border-medium);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
  opacity: 0.6;
}

.btn-danger {
  background: linear-gradient(135deg, #fc8181 0%, var(--error-red) 100%);
}

.btn-danger:hover {
  box-shadow: 0 4px 12px rgba(229, 62, 62, 0.3);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 24px;
  margin-top: 24px;
}

.stat-card {
  background: var(--white);
  padding: 24px;
  border-radius: 12px;
  text-align: left;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-light);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--color-green1), var(--color-green2));
}

.stat-card:hover {
  box-shadow: var(--shadow-lg);
  border-color: var(--color-green3);
}

.stat-card h3 {
  margin: 0 0 12px 0;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-light);
  font-weight: 600;
}

.stat-card .value {
  font-size: 40px;
  font-weight: 700;
  margin: 0;
  color: var(--text-dark);
  line-height: 1;
  background: linear-gradient(135deg, var(--color-green1), var(--color-green-dark));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.table-container {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid var(--border-light);
  margin-top: 20px;
}

table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

table th,
table td {
  padding: 16px 18px;
  text-align: left;
  border-bottom: 1px solid var(--border-light);
  font-size: 15px;
}

table th {
  background: linear-gradient(135deg, var(--color-green-dark) 0%, var(--color-green1) 100%);
  color: var(--white);
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: sticky;
  top: 0;
  z-index: 10;
}

table th:first-child {
  border-top-left-radius: 8px;
}

table th:last-child {
  border-top-right-radius: 8px;
}

table tbody tr {
  transition: all 0.2s ease;
}

table tbody tr:hover {
  background-color: var(--color-green-light);
}

table tbody tr:last-child td {
  border-bottom: none;
}

table td {
  color: var(--text-medium);
  font-size: 14px;
}

.loading {
  text-align: center;
  padding: 60px 40px;
  color: var(--text-light);
  font-size: 17px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.loading::before {
  content: '';
  width: 48px;
  height: 48px;
  border: 4px solid var(--border-light);
  border-top-color: var(--color-green1);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.error {
  background: var(--white);
  border-left: 4px solid var(--error-red);
  color: var(--text-dark);
  padding: 16px 20px;
  border-radius: 8px;
  margin: 16px 0;
  box-shadow: var(--shadow-sm);
  display: flex;
  align-items: start;
  gap: 12px;
}

.error::before {
  content: '⚠️';
  font-size: 20px;
  flex-shrink: 0;
}

.success {
  background: var(--white);
  border-left: 4px solid var(--success-green);
  color: var(--text-dark);
  padding: 16px 20px;
  border-radius: 8px;
  margin: 16px 0;
  box-shadow: var(--shadow-sm);
  display: flex;
  align-items: start;
  gap: 12px;
}

.success::before {
  content: '✓';
  font-size: 20px;
  flex-shrink: 0;
  color: var(--color-green1);
  font-weight: bold;
}

.info {
  background: var(--white);
  border-left: 4px solid var(--color-purple);
  color: var(--text-dark);
  padding: 16px 20px;
  border-radius: 8px;
  margin: 16px 0;
  box-shadow: var(--shadow-sm);
  display: flex;
  align-items: start;
  gap: 12px;
}

.info::before {
  content: 'ℹ️';
  font-size: 20px;
  flex-shrink: 0;
}

.chart-container {
  margin-top: 24px;
  padding: 24px;
  background: var(--white);
  border-radius: 12px;
  border: 1px solid var(--border-light);
  box-shadow: var(--shadow-sm);
}

/* Input Styles */
input[type="text"],
input[type="search"],
textarea,
select {
  width: 100%;
  padding: 12px 16px;
  font-size: 16px;
  border: 2px solid var(--border-light);
  border-radius: 8px;
  transition: all 0.2s ease;
  font-family: inherit;
  background: var(--white);
  color: var(--text-dark);
}

input[type="text"]:focus,
input[type="search"]:focus,
textarea:focus,
select:focus {
  outline: none;
  border-color: var(--color-green1);
  box-shadow: 0 0 0 3px var(--color-green7);
}

input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: var(--color-green1);
  cursor: pointer;
}

/* Progress Bar Styles */
.progress-container {
  background: var(--bg-secondary);
  border-radius: 8px;
  padding: 20px;
  margin: 16px 0;
  border: 1px solid var(--border-light);
}

.progress-bar {
  height: 8px;
  background: var(--border-light);
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--color-green1), var(--color-green2));
  border-radius: 4px;
  transition: width 0.3s ease;
  position: relative;
  overflow: hidden;
}

.progress-fill::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

/* Badge Styles */
.badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.badge-success {
  background: var(--color-green4);
  color: var(--color-green-dark);
}

.badge-error {
  background: rgba(229, 62, 62, 0.1);
  color: var(--error-red);
}

.badge-info {
  background: var(--color-blue-light);
  color: var(--color-purple);
}

/* Responsive Design */
@media (max-width: 768px) {
  .container {
    padding: 16px;
  }
  
  .card {
    padding: 20px;
  }
  
  .nav {
    overflow-x: auto;
  }
  
  .nav button {
    padding: 12px 16px;
    font-size: 14px;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .header h1 {
    font-size: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,oDAAoD;EACpD,2BAA2B;EAC3B,mCAAmC;EACnC,4BAA4B;EAC5B,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,qCAAqC;EACrC,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,yBAAyB;EACzB,gFAAgF;EAChF,sFAAsF;EACtF,wFAAwF;EACxF,0FAA0F;AAC5F;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,wFAAwF;EACxF,iHAAiH;EACjH,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sGAAsG;EACtG,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAA0V;EAC1V,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE,kCAAkC;EAClC,uCAAuC;EACvC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,sCAAsC;EACtC,4CAA4C;EAC5C,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,mFAAmF;EACnF,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,6EAA6E;EAC7E,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,8FAA8F;EAC9F,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,8FAA8F;EAC9F,iCAAiC;EACjC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yFAAyF;EACzF,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iDAAiD;EACjD,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,qCAAqC;EACrC,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4EAA4E;AAC9E;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,iFAAiF;EACjF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,yFAAyF;EACzF,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,2CAA2C;EAC3C,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;;;;EAIE,aAAa;EACb,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,4EAA4E;EAC5E,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,sFAAsF;EACtF,8BAA8B;AAChC;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[":root {\n  /* NMBU Color Palette - Professional Design System */\n  --color-green-dark: #025c4f;\n  --color-green-dark-default: #025c4f;\n  --color-green-light: #dbf8f4;\n  --color-green-light-default: #dbf8f4;\n  --color-green: #025c4f;\n  --color-green1: #009a81;\n  --color-green2: #46b4a0;\n  --color-green3: #8bcec0;\n  --color-green4: #d1e8df;\n  --color-green6: #247761;\n  --color-green7: rgba(0, 154, 129, .5);\n  --color-purple: #53143a;\n  --color-beige: #e7e3d1;\n  --color-beige-light: #f6f6ee;\n  --color-pink-light: #efc3cd;\n  --color-blue-light: #d4ddef;\n  --color-neutral: #333;\n  --color-neutral1: #4d4d4d;\n  --color-neutral2: #999;\n  --color-neutral3: #e6e6e6;\n  --color-neutral4: #f0f0f0;\n  --color-neutral5: #c4c4c4;\n  \n  /* Semantic Mappings */\n  --primary-green: #009a81;\n  --primary-green-light: #46b4a0;\n  --primary-green-dark: #025c4f;\n  --primary-blue: #d4ddef;\n  --primary-blue-dark: #53143a;\n  --accent-purple: #53143a;\n  --accent-pink: #efc3cd;\n  --text-dark: #333;\n  --text-medium: #4d4d4d;\n  --text-light: #999;\n  --bg-primary: #f6f6ee;\n  --bg-secondary: #e7e3d1;\n  --border-light: #e6e6e6;\n  --border-medium: #c4c4c4;\n  --white: #ffffff;\n  --error-red: #d32f2f;\n  --success-green: #009a81;\n  --warning-yellow: #ffa726;\n  --shadow-sm: 0 1px 3px 0 rgba(2, 92, 79, 0.1), 0 1px 2px 0 rgba(2, 92, 79, 0.06);\n  --shadow-md: 0 4px 6px -1px rgba(2, 92, 79, 0.1), 0 2px 4px -1px rgba(2, 92, 79, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(2, 92, 79, 0.1), 0 4px 6px -2px rgba(2, 92, 79, 0.05);\n  --shadow-xl: 0 20px 25px -5px rgba(2, 92, 79, 0.1), 0 10px 10px -5px rgba(2, 92, 79, 0.04);\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.App {\n  min-height: 100vh;\n  background: linear-gradient(135deg, var(--bg-primary) 0%, var(--color-beige-light) 100%);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\n  font-size: 17px;\n  line-height: 1.6;\n  color: var(--text-dark);\n}\n\n.header {\n  background: linear-gradient(135deg, var(--color-green-dark) 0%, #1a6b5a 50%, var(--color-green6) 100%);\n  color: var(--white);\n  padding: 18px 32px;\n  box-shadow: 0 2px 12px rgba(2, 92, 79, 0.25);\n  position: relative;\n  overflow: hidden;\n  z-index: 101;\n}\n\n.header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg width=\"100\" height=\"100\" xmlns=\"http://www.w3.org/2000/svg\"><defs><pattern id=\"grid\" width=\"40\" height=\"40\" patternUnits=\"userSpaceOnUse\"><path d=\"M 40 0 L 0 0 0 40\" fill=\"none\" stroke=\"rgba(255,255,255,0.05)\" stroke-width=\"1\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url(%23grid)\"/></svg>');\n  opacity: 0.3;\n}\n\n.header h1 {\n  margin: 0;\n  font-size: 26px;\n  font-weight: 700;\n  letter-spacing: -0.3px;\n  position: relative;\n  z-index: 1;\n}\n\n/* ── Crop Breadcrumb in Header ── */\n.back-to-crops-btn {\n  background: rgba(255,255,255,0.15);\n  border: 1px solid rgba(255,255,255,0.3);\n  color: #ffffff;\n  padding: 8px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  position: relative;\n  z-index: 1;\n  white-space: nowrap;\n}\n\n.back-to-crops-btn:hover {\n  background: rgba(255,255,255,0.25);\n  transform: translateX(-2px);\n}\n\n.crop-breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255,255,255,0.12);\n  padding: 6px 16px;\n  border-radius: 20px;\n  position: relative;\n  z-index: 1;\n}\n\n.crop-breadcrumb-icon {\n  font-size: 22px;\n}\n\n.crop-breadcrumb-name {\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: 0.3px;\n}\n\n.nav {\n  background: var(--white);\n  padding: 0;\n  display: flex;\n  align-items: center;\n  gap: 0;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.06);\n  border-bottom: 1px solid var(--border-light);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  overflow-x: auto;\n}\n\n.nav-divider {\n  display: block;\n  width: 1px;\n  height: 24px;\n  background: linear-gradient(180deg, transparent, var(--border-medium), transparent);\n  margin: 0 6px;\n  flex-shrink: 0;\n}\n\n.nav button {\n  background: none;\n  border: none;\n  color: var(--text-medium);\n  cursor: pointer;\n  padding: 14px 22px;\n  font-size: 15px;\n  font-weight: 500;\n  border-bottom: 3px solid transparent;\n  transition: all 0.15s ease;\n  position: relative;\n  white-space: nowrap;\n}\n\n.nav button:hover {\n  color: var(--color-green-dark);\n  background-color: rgba(0, 154, 129, 0.06);\n}\n\n.nav button.active {\n  color: var(--color-green-dark);\n  font-weight: 600;\n  border-bottom-color: var(--color-green1);\n  background-color: rgba(0, 154, 129, 0.05);\n}\n\n.nav button.active::after {\n  content: none;\n}\n\n.container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 32px 24px;\n}\n\n.card {\n  background: var(--white);\n  border-radius: 12px;\n  padding: 28px;\n  margin-bottom: 24px;\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border-light);\n}\n\n.card:hover {\n  box-shadow: var(--shadow-md);\n}\n\n.card h2 {\n  margin: 0 0 20px 0;\n  color: var(--text-dark);\n  font-size: 26px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid var(--border-light);\n}\n\n.card h2::before {\n  content: '';\n  width: 4px;\n  height: 28px;\n  background: linear-gradient(180deg, var(--color-green1), var(--color-green6));\n  border-radius: 4px;\n}\n\n.upload-section {\n  border: 2px dashed var(--border-medium);\n  border-radius: 12px;\n  padding: 48px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  background: linear-gradient(135deg, rgba(0, 154, 129, 0.03) 0%, rgba(70, 180, 160, 0.03) 100%);\n  position: relative;\n  overflow: hidden;\n}\n\n.upload-section::before {\n  content: '📁';\n  font-size: 64px;\n  opacity: 0.1;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n}\n\n.upload-section:hover {\n  background: linear-gradient(135deg, rgba(0, 154, 129, 0.08) 0%, rgba(70, 180, 160, 0.08) 100%);\n  border-color: var(--color-green1);\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n\n.upload-section input[type=\"file\"] {\n  display: none;\n}\n\n.btn {\n  background: linear-gradient(135deg, var(--color-green1) 0%, var(--color-green-dark) 100%);\n  color: var(--white);\n  border: none;\n  padding: 12px 28px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: var(--shadow-sm);\n  letter-spacing: 0.3px;\n  position: relative;\n  overflow: hidden;\n}\n\n.btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s;\n}\n\n.btn:hover::before {\n  left: 100%;\n}\n\n.btn:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.btn:active {\n  transform: translateY(0);\n  box-shadow: var(--shadow-sm);\n}\n\n.btn:disabled {\n  background: var(--border-medium);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n  opacity: 0.6;\n}\n\n.btn-danger {\n  background: linear-gradient(135deg, #fc8181 0%, var(--error-red) 100%);\n}\n\n.btn-danger:hover {\n  box-shadow: 0 4px 12px rgba(229, 62, 62, 0.3);\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 24px;\n  margin-top: 24px;\n}\n\n.stat-card {\n  background: var(--white);\n  padding: 24px;\n  border-radius: 12px;\n  text-align: left;\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-light);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.stat-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--color-green1), var(--color-green2));\n}\n\n.stat-card:hover {\n  box-shadow: var(--shadow-lg);\n  border-color: var(--color-green3);\n}\n\n.stat-card h3 {\n  margin: 0 0 12px 0;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-light);\n  font-weight: 600;\n}\n\n.stat-card .value {\n  font-size: 40px;\n  font-weight: 700;\n  margin: 0;\n  color: var(--text-dark);\n  line-height: 1;\n  background: linear-gradient(135deg, var(--color-green1), var(--color-green-dark));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.table-container {\n  overflow-x: auto;\n  border-radius: 8px;\n  border: 1px solid var(--border-light);\n  margin-top: 20px;\n}\n\ntable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\ntable th,\ntable td {\n  padding: 16px 18px;\n  text-align: left;\n  border-bottom: 1px solid var(--border-light);\n  font-size: 15px;\n}\n\ntable th {\n  background: linear-gradient(135deg, var(--color-green-dark) 0%, var(--color-green1) 100%);\n  color: var(--white);\n  font-weight: 600;\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\ntable th:first-child {\n  border-top-left-radius: 8px;\n}\n\ntable th:last-child {\n  border-top-right-radius: 8px;\n}\n\ntable tbody tr {\n  transition: all 0.2s ease;\n}\n\ntable tbody tr:hover {\n  background-color: var(--color-green-light);\n}\n\ntable tbody tr:last-child td {\n  border-bottom: none;\n}\n\ntable td {\n  color: var(--text-medium);\n  font-size: 14px;\n}\n\n.loading {\n  text-align: center;\n  padding: 60px 40px;\n  color: var(--text-light);\n  font-size: 17px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.loading::before {\n  content: '';\n  width: 48px;\n  height: 48px;\n  border: 4px solid var(--border-light);\n  border-top-color: var(--color-green1);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.error {\n  background: var(--white);\n  border-left: 4px solid var(--error-red);\n  color: var(--text-dark);\n  padding: 16px 20px;\n  border-radius: 8px;\n  margin: 16px 0;\n  box-shadow: var(--shadow-sm);\n  display: flex;\n  align-items: start;\n  gap: 12px;\n}\n\n.error::before {\n  content: '⚠️';\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.success {\n  background: var(--white);\n  border-left: 4px solid var(--success-green);\n  color: var(--text-dark);\n  padding: 16px 20px;\n  border-radius: 8px;\n  margin: 16px 0;\n  box-shadow: var(--shadow-sm);\n  display: flex;\n  align-items: start;\n  gap: 12px;\n}\n\n.success::before {\n  content: '✓';\n  font-size: 20px;\n  flex-shrink: 0;\n  color: var(--color-green1);\n  font-weight: bold;\n}\n\n.info {\n  background: var(--white);\n  border-left: 4px solid var(--color-purple);\n  color: var(--text-dark);\n  padding: 16px 20px;\n  border-radius: 8px;\n  margin: 16px 0;\n  box-shadow: var(--shadow-sm);\n  display: flex;\n  align-items: start;\n  gap: 12px;\n}\n\n.info::before {\n  content: 'ℹ️';\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.chart-container {\n  margin-top: 24px;\n  padding: 24px;\n  background: var(--white);\n  border-radius: 12px;\n  border: 1px solid var(--border-light);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Input Styles */\ninput[type=\"text\"],\ninput[type=\"search\"],\ntextarea,\nselect {\n  width: 100%;\n  padding: 12px 16px;\n  font-size: 16px;\n  border: 2px solid var(--border-light);\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  font-family: inherit;\n  background: var(--white);\n  color: var(--text-dark);\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"search\"]:focus,\ntextarea:focus,\nselect:focus {\n  outline: none;\n  border-color: var(--color-green1);\n  box-shadow: 0 0 0 3px var(--color-green7);\n}\n\ninput[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: var(--color-green1);\n  cursor: pointer;\n}\n\n/* Progress Bar Styles */\n.progress-container {\n  background: var(--bg-secondary);\n  border-radius: 8px;\n  padding: 20px;\n  margin: 16px 0;\n  border: 1px solid var(--border-light);\n}\n\n.progress-bar {\n  height: 8px;\n  background: var(--border-light);\n  border-radius: 4px;\n  overflow: hidden;\n  position: relative;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--color-green1), var(--color-green2));\n  border-radius: 4px;\n  transition: width 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.progress-fill::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n  animation: shimmer 2s infinite;\n}\n\n@keyframes shimmer {\n  0% { transform: translateX(-100%); }\n  100% { transform: translateX(100%); }\n}\n\n/* Badge Styles */\n.badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n}\n\n.badge-success {\n  background: var(--color-green4);\n  color: var(--color-green-dark);\n}\n\n.badge-error {\n  background: rgba(229, 62, 62, 0.1);\n  color: var(--error-red);\n}\n\n.badge-info {\n  background: var(--color-blue-light);\n  color: var(--color-purple);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .container {\n    padding: 16px;\n  }\n  \n  .card {\n    padding: 20px;\n  }\n  \n  .nav {\n    overflow-x: auto;\n  }\n  \n  .nav button {\n    padding: 12px 16px;\n    font-size: 14px;\n  }\n  \n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .header h1 {\n    font-size: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
